import { useEffect, useState } from 'react';
import './App.css';
import abi from './contracts/snakeAbi.json';
import { ethers, BigNumber } from 'ethers';
import space from './img/space.gif';
//import game from './game.html';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import twitter from './img/twitter-logo.png';
import discord from './img/Discord-icon.png';
import opensea from './img/OpenSea-icon.png';

const contractAddress = "0x66aF8728fCEA664f0AfCfCA1550a487d1babe40b";

function App() {

  const [currentAccount, setCurrentAccount] = useState(null);
  const [minted, setMinted] = useState(false);
  const [totalSupply, setTotalSupply] = useState("");
  const [supply, setSupply] = useState("");
  //const [paused, setPaused] = useState(false);
  const [mintNb, setMintNb] = useState('');
  const [Price, setPrice] = useState(null);

  const checkNetwork = async () =>{
    const { ethereum } = window;
    const provider = new ethers.providers.Web3Provider(ethereum);
    var chain = await provider.getNetwork();

    if(chain.chainId !== 1){
      alert("Wrong network");
      setCurrentAccount(null);
      return false;
    }
    return true;
  }

  const connectWalletHandler = async () => {
    const { ethereum } = window;

    if (!ethereum) {
      alert("Please install Metamask!");
    }
    if(!checkNetwork())
      return;

    try {
      const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
      console.log("Found an account! Address: ", accounts[0]);
      setCurrentAccount(accounts[0]);
    } catch (err) {
      alert(err);
    }
  }

  const freeMintNftHandler = async () => {
    try {
      const { ethereum } = window;

      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const nftContract = new ethers.Contract(contractAddress, abi, signer);

        console.log("Initialize payment");
        let nftTxn = await nftContract.freeMint();

        console.log("Minting... please wait");
        await nftTxn.wait();

        console.log(`Mined, see transaction: https://etherscan.io/tx/${nftTxn.hash}`);
        setMinted(true);

      } else {
        console.log("Ethereum object does not exist");
        alert("Ethereum object does not exist");
      }

    } catch (err) {
      console.log(err);
      alert(err);
    }
  }

  const mintNftHandler = async () => {
    try {
      const { ethereum } = window;

      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const nftContract = new ethers.Contract(contractAddress, abi, signer);

        var values = BigNumber.from((mintNb * Price).toString());

        console.log("Initialize payment");
        let nftTxn = await nftContract.mint(mintNb, { value: values });

        console.log("Minting... please wait");
        await nftTxn.wait();

        console.log(`Minted, see transaction: https://etherscan.io/tx/${nftTxn.hash}`);
        setMinted(true);

      } else {
        console.log("Ethereum object does not exist");
        alert("Ethereum object does not exist");
      }

    } catch (err) {
      console.log(err);
      alert(err);
    }
  }

  const connectWalletButton = () => {
    return (
      <button onClick={connectWalletHandler} className='cta-button connect-wallet-button'>
        Connect Wallet
      </button>
    )
  }

  const handleChange = (event) => {
    setMintNb(event.target.value);
  };

  const mintNbField = () => {
    if (currentAccount) {
      return (
        <div><FormControl sx={{ m: 1, minWidth: 80 }}>
          <Select
            id="demo-simple-select"
            value={mintNb}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
            onChange={handleChange}
          >
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={2}>2</MenuItem>
            <MenuItem value={3}>3</MenuItem>
            <MenuItem value={4}>4</MenuItem>
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={6}>6</MenuItem>
            <MenuItem value={7}>7</MenuItem>
            <MenuItem value={8}>8</MenuItem>
            <MenuItem value={9}>9</MenuItem>
            <MenuItem value={10}>10</MenuItem>
          </Select>
        </FormControl>
          <button onClick={mintNftHandler} className='cta-button mint-nft-button'>
            Mint NFT (0.005) each
          </button>
        </div>

      )
    }
  }

  const mintNftButton = () => {
    if (!minted) {
      return (
        <button onClick={freeMintNftHandler} className='cta-button mint-nft-button'>
          Get FreeMint NFT
        </button>
      )
    }
    return "";
  }

  useEffect(() => {
    const getVariables = async () => {
      try {
        const { ethereum } = window;
        if (ethereum) {
          const provider = new ethers.providers.Web3Provider(ethereum);
          const signer = provider.getSigner();
          const nftContract = new ethers.Contract(contractAddress, abi, signer);
          setTotalSupply(await nftContract.totalSupply());
          setSupply(await nftContract.MAX_SUPPLY());
          if(currentAccount)
            var nbr = await nftContract.minted(currentAccount.adress);
          if(nbr)
            setMinted(nbr.toNumber() > 0 ? true : false);
          //setPaused(await nftContract.paused());
          setPrice(await nftContract.price());
        } else {
          console.log("Ethereum object does not exist");
        }

      } catch (err) {
        console.log(err);
      }
    }
    const checkWalletIsConnected = async () => {
      const { ethereum } = window;
  
      if (!ethereum) {
        console.log("Make sure you have Metamask installed!");
        return;
      } else {
        console.log("Wallet exists! We're ready to go!")
      }
      if(!checkNetwork())
        return;
  
      const accounts = await ethereum.request({ method: 'eth_accounts' });
  
      if (accounts.length !== 0) {
        const account = accounts[0];
        console.log("Found an authorized account: ", account);
        setCurrentAccount(account);
      } else {
        console.log("No authorized account found");
      }
    }
    checkWalletIsConnected();
    getVariables();
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className='main-app'>
      <img src={space} alt="space" className='spaceLogo' />
      <h1>Space Invaders NFT Mint</h1>
      <div>
        Sold out !
      </div>
      {"Minted :" + totalSupply + "/" + supply}
      <div className='logoBottom'>
        <img src={twitter} alt='' className="logoTwitter" onClick={() => window.open("https://twitter.com/NFT_Games_Labs")}></img>
        <img src={discord} alt='' className="logoDiscord" onClick={() => window.open("https://discord.gg/y84kdZhkXN")}></img>
        <img src={opensea} alt='' className="logoOS" onClick={() => window.open("https://opensea.io/collection/space-invaders-game-nft")}></img>
      </div>
    </div>
  )
}

export default App;
